module.exports = __webpack_public_path__ + "img/sales.de6e4274.png";